import { appTemplates } from "@biz/definitions/ArticleShopTemplates";
import { LoungeData, ReloadData, UnpluggedData } from "@biz/definitions/LoungeData";
import { ILoungeData } from "@biz/definitions/LoungeDefinitions";
import { CalcProductLogic } from "@biz/items/CalcProductLogic";
import { FieldErrorMap } from "@biz/models/FieldErrorMap";
import { PD } from "@biz/PD";
import { ICalcContext, ICalculatedProductResult } from "@biz/projectCalculation/ProjectDefinitions";

export class CalcLounge3dLogic {
  static calc3d(product: ILoungeData, slc: ICalcContext): ICalculatedProductResult {
    if (product.loungeType === "Reload") {
      const chairs = LoungeData.getItems(product);
      for (let i = 0; i < chairs.length; i++) {
        const articleNumbers = ReloadData.getArticleNumbers(product, i);
        for (const articleNumber of articleNumbers) {
          CalcProductLogic.addRuleArticle(slc, articleNumber.articleNumber, {
            count: 1, articleType: "obligatory",
            featureTemplate: appTemplates.lounge,
            features: { colorId: articleNumber.colorId }
          });
        }
      }
      // CalcSailLogic.addWarning(slc.errors, "product", "Test Fehler!");
    } else if (product.loungeType === "Unplugged") {
      const chairs = LoungeData.getItems(product);
      for (let i = 0; i < chairs.length; i++) {
        const articleNumbers = UnpluggedData.getArticleNumbers(product, i);
        for (const articleNumber of articleNumbers) {
          CalcProductLogic.addRuleArticle(slc, articleNumber.articleNumber, {
            count: 1, articleType: "obligatory",
            featureTemplate: appTemplates.lounge,
            features: { colorId: articleNumber.colorId }
          });
        }
      }
    }
    // CalcSailLogic.addWarning(slc.errors, "product", "Test Fehler!");

    CalcProductLogic.finalizeCalcContext(slc, { incomplete: !product, defaultOfferList: "H", count: product.count });

    return {
      id: product.id,
      pd: PD.productToPD(product),
      infos: slc.infos,
      errors: slc.errors,
      errorMap: FieldErrorMap.errorMapFromErrors(slc.errors || []),
      articles: slc.ruleArticles,
      // modified: product,
      product,
      // modifiedSunSail: sunSail,
    };
  }
}